import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel } from '../../_models/user.model';
import { environment } from '../../../../../environments/environment';
import { AuthModel } from '../../_models/auth.model';

const API_USERS_URL = `${environment.apiUrl}/users`;

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) { }

  // public methods
  login(email: string, password: string): Observable<any> {

    return this.http.post<AuthModel>(`${environment.apiUrl}/t/auth/login`,   { email, password });
  }

  // CREATE =>  POST: add a new user to the server
  createUser(user: UserModel): Observable<{success:boolean, data:any, message: string}> {
    return this.http.post<{success:boolean, data:any, message: string}>(`${environment.apiUrl}/t/auth/register`, user);
  }

  // Your server should check email => If email exists send link to the user and return true | If email doesn't exist return false
  forgotPassword(email: string): Observable<boolean> {
    return this.http.post<boolean>(`${environment.apiUrl}/t/auth/forgot-password`, {
      email,
    });
  }

  getUserByToken(token): Observable<{success:boolean, data:UserModel}> {
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<{success:boolean, data:UserModel}>(`${environment.apiUrl}/t/users/me`, {
      headers: httpHeaders,
    });
  }
}
